<template>
  <div class="app-container">
    <div class="card">
      <el-form
        ref="form"
        :model="queryParams"
        :inline="true"
        @keyup.enter.native="handleQuery"
      >
        <el-form-item label="企业名称：">
          <el-input
            v-model="queryParams.unitName"
            placeholder="请输入企业名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="发送公司：">
          <el-input
            v-model="queryParams.sendUnitName"
            placeholder="请输入发送公司"
            clearable
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="状态：">
          <el-select
            v-model="queryParams.status"
            placeholder="请选择状态"
            clearable
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">
            搜 索
          </el-button>
          <el-button icon="el-icon-delete" @click="handleReset">
            重 置
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="mainContainer">
      <!-- 审核状态 tab + 批量审核按钮 -->
      <div class="toponsd">
        <el-tabs v-model="queryParams.activeName" @tab-click="handleTabClick">
          <el-tab-pane label="待审核" name="pending" />
          <el-tab-pane label="已接收" name="received" />
          <el-tab-pane label="已拒绝" name="rejected" />
        </el-tabs>
        <!-- <el-button
          v-if="queryParams.activeName === 'pending'"
          class="batch-btn"
          type="primary"
          :disabled="selectedRows.length === 0"
          @click="openBatchAuditDialog"
        >
          批量审核
        </el-button> -->
      </div>

      <!-- 列表 -->
      <div class="table-container">
        <el-table
          ref="recordTable"
          v-loading="loading"
          :data="tableData"
          border
          height="100%"
          @selection-change="handleSelectionChange"
        >
          <!-- 仅待审核 tab 显示多选列 -->
          <!-- <el-table-column
            v-if="queryParams.activeName === 'pending'"
            type="selection"
            width="55"
            align="center"
          /> -->
          <el-table-column prop="id" label="发送编号" align="center" />
          <el-table-column prop="unitName" label="企业名称" align="center" />
          <el-table-column
            prop="certificateNumber"
            label="证件编号"
            align="center"
          />
          <el-table-column
            prop="sendUnitName"
            label="发送公司"
            align="center"
          />
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="{ row }">
              <el-tooltip
                v-if="row.status == 3"
                effect="dark"
                :content="row.remark"
                placement="top"
              >
                <span class="status-cell">
                  <span> {{ getStatusLabel(row.status) }}</span>
                  <span class="status-reason-icon">?</span>
                </span>
              </el-tooltip>
              <span v-else class="status-cell">
                {{ getStatusLabel(row.status) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="sender" label="发送人" align="center" />
          <el-table-column prop="sendTime" label="发送时间" align="center" />

          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="{ row }">
              <!-- 仅待审核状态显示「审核」 -->
              <span
                v-if="row.status == 1"
                class="btsed"
                @click="openAudit(row)"
              >
                审核
              </span>
              <!-- 其他状态仅显示「资料快照」 -->
              <span v-else class="btsed" @click="openSnapshot(row)">
                资料快照
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.currPage"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>

    <CustInformation
      v-model="snapshotVisible"
      :customerId="snapshotRow.customerId"
      :routerType="2"
      entryMode="snapshot"
      @closed="snapshotVisible = false"
    />
    <CustInformation
      v-model="auditVisible"
      :customerId="auditRow.customerId || auditRow.id"
      :routerType="2"
      entryMode="audit"
      @auditApprove="onAuditApprove"
      @auditReject="onAuditReject"
      @closed="auditVisible = false"
    />

    <!-- 单条不通过原因弹窗 -->
    <el-dialog
      title="不通过原因"
      :visible.sync="rejectDialogVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="rejectFormRef"
        :model="rejectForm"
        :rules="rejectRules"
        label-width="100px"
      >
        <el-form-item label="原因：" prop="remark">
          <el-input
            v-model="rejectForm.remark"
            type="textarea"
            :rows="4"
            maxlength="200"
            show-word-limit
            placeholder="请输入不通过原因"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeRejectDialog">取 消</el-button>
        <el-button type="primary" :loading="auditLoading" @click="confirmReject"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 批量审核弹窗 -->
    <el-dialog
      title="批量审核"
      :visible.sync="batchAuditVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <div class="batch-audit-body">
        <i class="el-icon-warning batch-audit-icon"></i>
        <div>
          <div class="batch-audit-title">
            已选择{{ selectedRows.length }}家客户，请选择审核意见
          </div>
          <div class="batch-audit-sub">
            请确保已全部审阅客户资质，符合标准后提交
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchAuditVisible = false">取 消</el-button>
        <el-button :loading="batchLoading" @click="handleBatchReject">
          不通过
        </el-button>
        <el-button
          type="primary"
          :loading="batchLoading"
          @click="handleBatchApprove"
        >
          通 过
        </el-button>
      </div>
    </el-dialog>

    <!-- 批量不通过原因弹窗 -->
    <el-dialog
      title="批量不通过原因"
      :visible.sync="batchRejectVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="batchRejectFormRef"
        :model="batchRejectForm"
        :rules="rejectRules"
        label-width="100px"
      >
        <el-form-item label="原因：" prop="remark">
          <el-input
            v-model="batchRejectForm.remark"
            type="textarea"
            :rows="4"
            maxlength="200"
            show-word-limit
            placeholder="请输入不通过原因"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchRejectVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="batchLoading"
          @click="confirmBatchReject"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getQualificationShareRecord,
  receiveAudit,
  batchReceiveAudit,
} from "@/api/appApi/appapi.js";

export default {
  name: "",
  data() {
    return {
      queryParams: {
        currPage: 1, // 页码
        pageSize: 10, // 每页大小
        unitName: "", // 企业名称
        sendUnitName: "", // 发送公司
        status: "1", // 状态，默认待审核
        activeName: "pending", // tab 状态
      },

      statusOptions: [
        { label: "待审核", value: "1" },
        { label: "已接收", value: "2" },
        { label: "已拒绝", value: "3" },
      ],

      total: 0,
      loading: false,
      tableData: [], // 列表
      selectedRows: [], // 批量选中行

      snapshotVisible: false,
      snapshotRow: {},
      auditVisible: false,
      auditRow: {},
      auditLoading: false,
      rejectDialogVisible: false,
      rejectForm: {
        remark: "",
      },
      rejectRules: {
        remark: [
          { required: true, message: "请输入不通过原因", trigger: "blur" },
        ],
      },

      batchAuditVisible: false, // 批量审核弹窗
      batchRejectVisible: false, // 批量不通过原因弹窗
      batchLoading: false,
      batchRejectForm: {
        remark: "",
      },
    };
  },

  created() {
    this.getList();
  },
  methods: {
    /** 查询列表数据 */
    async getList() {
      this.loading = true;
      const params = {
        type: 2, // 2:接收记录
        unitName: this.queryParams.unitName,
        sendUnitName: this.queryParams.sendUnitName,
        status: this.queryParams.status,
        pageNumber: this.queryParams.currPage,
        pageSize: this.queryParams.pageSize,
      };
      const res = await getQualificationShareRecord(params);
      this.loading = false;
      if (res.code == "000000") {
        this.tableData = res.content.list || [];
        this.total = res.content.totalRecords || 0;
      }
      this.clearSelection();
    },
    // 切换审核状态 tab
    handleTabClick() {
      const statusMap = {
        pending: "1",
        received: "2",
        rejected: "3",
      };
      this.queryParams.currPage = 1;
      this.queryParams.status = statusMap[this.queryParams.activeName] || "";
      this.getList();
    },
    // 表格多选变化
    handleSelectionChange(list) {
      this.selectedRows = list || [];
    },
    // 清空表格选中
    clearSelection() {
      this.selectedRows = [];
      this.$nextTick(() => {
        this.$refs.recordTable && this.$refs.recordTable.clearSelection();
      });
    },
    // 查询按钮操作
    handleQuery() {
      this.queryParams.currPage = 1;
      this.getList();
    },
    // 重置
    handleReset() {
      const activeName = this.queryParams.activeName;
      Object.assign(this.queryParams, this.$options.data().queryParams);
      this.queryParams.activeName = activeName;
      const statusMap = {
        pending: "1",
        received: "2",
        rejected: "3",
      };
      this.queryParams.status = statusMap[activeName] || "1";
      this.getList();
    },
    openSnapshot(row) {
      this.snapshotRow = row || {};
      this.snapshotVisible = true;
    },
    openAudit(row) {
      this.auditRow = row || {};
      this.auditVisible = true;
    },
    // 打开批量审核弹窗
    openBatchAuditDialog() {
      if (!this.selectedRows.length) {
        this.$message.warning("请先选择待审核记录");
        return;
      }
      this.batchAuditVisible = true;
    },
    // 批量审核通过
    async handleBatchApprove() {
      const idList = this.selectedRows.map((row) => row.id).filter(Boolean);
      if (!idList.length) {
        this.$message.warning("缺少审核记录ID");
        return;
      }
      this.batchLoading = true;
      const res = await this.submitBatchAudit(idList, 2, "");
      this.batchLoading = false;
      if (res) {
        this.$message.success("批量审核已通过");
        this.batchAuditVisible = false;
        this.getList();
      }
    },
    // 批量审核不通过（打开原因弹窗）
    handleBatchReject() {
      this.batchRejectForm.remark = "";
      this.batchRejectVisible = true;
      this.$nextTick(() => {
        this.$refs.batchRejectFormRef &&
          this.$refs.batchRejectFormRef.clearValidate();
      });
    },
    // 确认批量不通过
    async confirmBatchReject() {
      const valid = await this.$refs.batchRejectFormRef
        .validate()
        .catch(() => false);
      if (!valid) return;
      const idList = this.selectedRows.map((row) => row.id).filter(Boolean);
      if (!idList.length) {
        this.$message.warning("缺少审核记录ID");
        return;
      }
      this.batchLoading = true;
      const res = await this.submitBatchAudit(
        idList,
        3,
        this.batchRejectForm.remark
      );
      this.batchLoading = false;
      if (res) {
        this.$message.success("批量审核已不通过");
        this.batchRejectVisible = false;
        this.batchAuditVisible = false;
        this.getList();
      }
    },
    // 提交批量审核（优先批量接口，失败则逐条审核）
    async submitBatchAudit(idList, status, remark) {
      const batchRes = await batchReceiveAudit({
        idList,
        status,
        remark,
      });
      if (batchRes.code == "000000") return true;

      // 批量接口不可用时，降级为逐条调用
      const results = await Promise.all(
        idList.map((id) => receiveAudit({ id, status, remark }))
      );
      const allSuccess = results.every((item) => item.code == "000000");
      if (!allSuccess) {
        this.$message.error("部分记录审核失败，请重试");
        return false;
      }
      return true;
    },
    async onAuditApprove() {
      const id = this.auditRow && this.auditRow.id;
      if (!id) {
        this.$message.warning("缺少审核记录ID");
        return;
      }
      this.auditLoading = true;
      const res = await receiveAudit({ id, status: 2, remark: "" });
      this.auditLoading = false;
      if (res.code == "000000") {
        this.$message.success("已通过");
        this.auditVisible = false;
        this.getList();
      }
    },
    onAuditReject() {
      this.rejectDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.rejectFormRef && this.$refs.rejectFormRef.clearValidate();
      });
    },
    closeRejectDialog() {
      this.rejectDialogVisible = false;
      this.rejectForm.remark = "";
    },
    async confirmReject() {
      const valid = await this.$refs.rejectFormRef
        .validate()
        .catch(() => false);
      if (!valid) return;
      const id = this.auditRow && this.auditRow.id;
      if (!id) {
        this.$message.warning("缺少审核记录ID");
        return;
      }
      this.auditLoading = true;
      const res = await receiveAudit({
        id,
        status: 3,
        remark: this.rejectForm.remark,
      });
      this.auditLoading = false;
      if (res.code == "000000") {
        this.$message.success("已不通过");
        this.closeRejectDialog();
        this.auditVisible = false;
        this.getList();
      }
    },
    getStatusLabel(status) {
      const val = String(status ?? "");
      if (val === "1") return "待审核";
      if (val === "2") return "已接收";
      if (val === "3") return "已拒绝";
      return status || "";
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-tabs__nav-wrap::after {
  background-color: #dfe4ed;
}
.toponsd {
  margin-left: 10px;
  position: relative;
  .batch-btn {
    position: absolute;
    top: 0;
    right: 10px;
  }
}
.batch-audit-body {
  display: flex;
  align-items: flex-start;
  padding: 10px 0;
}
.batch-audit-icon {
  font-size: 24px;
  color: #e6a23c;
  margin-right: 12px;
  margin-top: 2px;
}
.batch-audit-title {
  font-size: 15px;
  color: #303133;
  margin-bottom: 8px;
}
.batch-audit-sub {
  font-size: 13px;
  color: #909399;
}

.status-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  .status-reason-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    margin-left: 6px;
    border: 1px solid #c0c4cc;
    border-radius: 50%;
    color: #c0c4cc;
    font-size: 12px;
    line-height: 12px;
  }
}
</style>
